import React, { useEffect, useState } from "react";
import axios from "axios";
import ReCAPTCHA from "react-google-recaptcha";
// import VisibilityIcon from "@mui/icons-material/Visibility";
// import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { useNavigate } from "react-router-dom";
import { encryptText } from "../utils/cipherText";
import LoginSideImage from "../images/LoginSideImage";
import { MdOutlineVisibilityOff } from "react-icons/md";
import { MdOutlineVisibility } from "react-icons/md";

const LoginPage = () => {
  let navigate = useNavigate();

  const [email, setEmail] = useState();
  const [password, setPassword] = useState();
  const [captchaFilled, setCaptchaFilled] = useState(false);
  const [passwordShow, setPasswordShow] = useState(false);
  const [invalidCred, setInvalidCred] = useState(false);
  const [validInput, setValidInput] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const [disabled, setDisabled] = useState(true);
  const [unAuthorizedError, setUnAuthorizedError] = useState(false);

  const emailValidation = (email) => {
    const regex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    return regex.test(email);
  };

  const handleLoginSubmit = async (e) => {
    e.preventDefault();
    if (!validInput) {
      setEmailError(true);
      return;
    } else {
      setEmailError(false);
    }

    if (
      (process.env.REACT_APP_CAPTCHA_RENDER === "true" || captchaFilled) &&
      validInput
    ) {
      try {
        const options = {
          url: `${process.env.REACT_APP_URL}/lender/login`,
          method: "POST",
          data: {
            email,
            password,
          },
        };
        const res = await axios(options);
        // console.log(res);
        if (
          !res.data.console.password_set &&
          res.data.console.lender_type === "distributors"
        ) {
          navigate(`/confirm-password/${res.data.token}`, {
            state: { validated: true },
          });
          return;
        }
        if (
          res.status === 200 &&
          res.data.token &&
          res.data.console.email === email
        ) {
          localStorage.setItem("token", res.data.token);
          localStorage.setItem("lender_id", res.data.console.lender_id);
          localStorage.setItem("lender_uuid", res.data.console.uuid);
          localStorage.setItem(
            "lender_type",
            encryptText(res.data.console.lender_type, 7)
          );
          res.data.console.lender_type !== "distributors"
            ? navigate("/dashboard")
            : navigate("/kyc");
        }
      } catch (error) {
        if (error.response.data.error === "Invalid username or password") {
          setInvalidCred(true);
        }
        if (error.response.status === 422) {
          setUnAuthorizedError(true);
        }
      }
    }
  };

  function onCaptchaChange(value) {
    // console.log("Captcha value:", value);
    setCaptchaFilled((prev) => !prev);
  }

  useEffect(() => {
    if (
      email &&
      password &&
      (process.env.REACT_APP_CAPTCHA_RENDER === "true" || captchaFilled)
    ) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  }, [email, password, captchaFilled]);

  return (
    <div className="login-main-wrap flex bg-white font-[Inter,sans-serif]">
      <div className="login-side-image max-lg:hidden  w-[50vw] h-[100vh] flex items-center justify-center bg-custom">
        <LoginSideImage />
      </div>
      <div className="login-form-wrap max-lg:w-[100vw] w-[50vw] h-[100vh] flex items-center justify-center">
        <form
          className="login-form max-lg:w-[80vw] max-lg:p-3 max-md:w-[90vw] min-h-[60vh] w-[30vw] text-[13px]"
          onSubmit={handleLoginSubmit}
        >
          <h1 className="w-full flex items-center justify-center mb-12 text-3xl font-medium">
            Login
          </h1>
          {/* <FinsireLoginLogo /> */}
          {invalidCred && (
            <div
              class="bg-red-100  border-red-400 text-red-700 px-4 py-3 rounded relative mb-3 size w-full"
              role="alert"
            >
              <strong class="font-bold">Invalid! </strong>
              <span class="block sm:inline">Check Email or Password</span>
            </div>
          )}
          {emailError && (
            <div
              class="bg-red-100  border-red-400 text-red-700 px-4 py-3 rounded relative mb-3 size w-full"
              role="alert"
            >
              <strong class="font-bold">Error! </strong>
              <span class="block sm:inline">Provide a valid Email</span>
            </div>
          )}
          {unAuthorizedError && (
            <div
              class="bg-red-100  border-red-400 text-red-700 px-4 py-3 rounded relative mb-3 size w-full"
              role="alert"
            >
              <strong class="font-bold"> Unauthorized!</strong>
              <span class="block sm:inline"> Please contact your lender</span>
            </div>
          )}
          <div className="form-input flex flex-col w-full">
            <label className="m-0 p-0 bottom-0 font-semibold">Email</label>
            <input
              type="email"
              name="email"
              id="email"
              style={{ outlineColor: "#d1d5db" }}
              // className="mt-0 font-normal "
              className={`mt-[0.29rem] shadow mb-4 ml-[0.2rem] mr-[0.2rem] font-normal rounded   w-full border-style h-10 pt-0 pb-0 pl-4 pr-4 outline-1 outline ${
                invalidCred ? "" : ""
              }`}
              onChange={(e) => {
                setEmail(e.target.value);
                setInvalidCred(false);
                setEmailError(false);
                setValidInput(emailValidation(e.target.value));
                setUnAuthorizedError(false);
              }}
              value={email}
              placeholder="Email address"
              required
            />
            <label className="m-0 p-0 bottom-0 font-semibold">Password</label>
            <div
              style={{ outlineColor: "#d1d5db" }}
              className={`password-input border-style shadow  rounded  w-full flex items-center h-10  mb-6 ml-[0.2rem] mt-[0.29rem] font-medium outline-1 outline `}
            >
              <input
                name="password"
                type={passwordShow ? "text" : "password"}
                id="password"
                className={`font-normal  outline-none pt-0 pb-0 pl-4 pr-4 w-[90%] m-0`}
                onChange={(e) => {
                  setPassword(e.target.value);
                  setInvalidCred(false);
                  setUnAuthorizedError(false);
                }}
                value={password}
                placeholder="Password"
                required
              />
              {!passwordShow && (
                <div
                  className="input-inside-div cursor-pointer "
                  onClick={() => setPasswordShow(true)}
                >
                  {/* <VisibilityOffIcon style={{ fontSize: "25px" }} /> */}

                  <MdOutlineVisibilityOff
                    style={{
                      fontSize: "23px",
                      color: "#d1d5db",
                    }}
                  />
                </div>
              )}
              {passwordShow && (
                <div
                  className="input-inside-div"
                  onClick={() => setPasswordShow(false)}
                >
                  {/* <VisibilityIcon style={{ fontSize: "25px" }} /> */}
                  <MdOutlineVisibility
                    style={{
                      fontSize: "23px",
                      color: "#d1d5db",
                    }}
                  />
                </div>
              )}
            </div>
          </div>
          {/* {invalidCred && (
            <div className="flex justify-center items-center mb-2">
              <div className="text-red-700 text-sm">
                <strong class="font-bold">Invalid! </strong>
                <span class="block sm:inline">Check Email or Password</span>
              </div>
            </div>
          )} */}
          <div
            className="recaptcha-div mb-4"
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <ReCAPTCHA
              sitekey={process.env.REACT_APP_URL_CAPTCHA_KEY}
              onChange={onCaptchaChange}
            />
          </div>
          {/* <div className="forgot-pw">
            <button
              className="fp-btn mb-10"
              type="button"
              onClick={(e) => {
                e.preventDefault();
                navigate("/forgotpassword", { replace: true });
              }}
            >
              <p>Forgot Password?</p>
            </button>
          </div> */}

          <button
            className="login-btn w-full pt-[10px] pb-[10px] pl-0 pr-0 text-base font-[550] rounded-md border-none text-[#00394d] cursor-pointer bg-gradient-to-r from-[#39bc00] to-[#a0ff77] font-[Inter]"
            disabled={disabled}
            type="submit"
            style={disabled ? { background: "gray", cursor: "default" } : {}}
          >
            Sign In
          </button>

          <div className="sign-up flex justify-end  mt-4 mb-[6px] ml-0 mr-0 font-normal text-sm">
            <p className=" text-[#00394d]">Don't have an account?</p>
            <a
              href="mailto:sales@finsire.com"
              className=" ml-[0.3rem] text-[#7cea51] no-underline"
            >
              Contact Us
            </a>
          </div>
        </form>
      </div>
    </div>
  );
};

export default LoginPage;
